// @core/api/endpoints/license/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ActivateLicense } from './activate_license';
import { CheckLicense } from './check_license';
import { DeactivateLicense } from './deactivate_license';
import { GetLicense } from './get_license';
import { GetLicenseAuditLogs } from './get_license_audit_logs';
import { GetLicenseStatus } from './get_license_status';
import { GetPublicKey } from './get_public_key';
import { GetUsageHistory } from './get_usage_history';
import { GetViolations } from './get_violations';
import { Heartbeat } from './heartbeat';
import { InputLicenseKey } from './input_license_key';
import { IssueLicense } from './issue_license';
import { ListLicenses } from './list_licenses';
import { RenewLicense } from './renew_license';
import { ReportUsage } from './report_usage';
import { ResumeLicense } from './resume_license';
import { RevokeLicense } from './revoke_license';
import { RotateSigningKey } from './rotate_signing_key';
import { SuspendLicense } from './suspend_license';
import { SyncLicense } from './sync_license';
import { UpdateLicenseEntitlements } from './update_license_entitlements';

// Re-export individual endpoints
export {
  ActivateLicense,
  CheckLicense,
  DeactivateLicense,
  GetLicense,
  GetLicenseAuditLogs,
  GetLicenseStatus,
  GetPublicKey,
  GetUsageHistory,
  GetViolations,
  Heartbeat,
  InputLicenseKey,
  IssueLicense,
  ListLicenses,
  RenewLicense,
  ReportUsage,
  ResumeLicense,
  RevokeLicense,
  RotateSigningKey,
  SuspendLicense,
  SyncLicense,
  UpdateLicenseEntitlements,
};

// Namespace export for convenient usage
export const licenseApi = {
  ActivateLicense,
  CheckLicense,
  DeactivateLicense,
  GetLicense,
  GetLicenseAuditLogs,
  GetLicenseStatus,
  GetPublicKey,
  GetUsageHistory,
  GetViolations,
  Heartbeat,
  InputLicenseKey,
  IssueLicense,
  ListLicenses,
  RenewLicense,
  ReportUsage,
  ResumeLicense,
  RevokeLicense,
  RotateSigningKey,
  SuspendLicense,
  SyncLicense,
  UpdateLicenseEntitlements,
};
